// Core
import styled from 'styled-components';

export const ListContainer = styled.div`
  padding-right: 1.5rem;
  padding-bottom: 2rem;
`;

export const Container = styled.div`
  padding-bottom: 2rem;
  height: 100%;
`;
